export const eur = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(Number(v) || 0);

export const INVOICE_STATUS = {
  brouillon: { label: "Brouillon", cls: "bg-neutral-100 text-neutral-600 border-neutral-200" },
  validee: { label: "Validée", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  envoyee: { label: "Envoyée", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  partiellement_payee: { label: "Partiellement payée", cls: "bg-yellow-50 text-yellow-700 border-yellow-200" },
  payee: { label: "Payée", cls: "bg-green-50 text-green-700 border-green-200" },
};

export const QUOTE_STATUS = {
  brouillon: { label: "Brouillon", cls: "bg-neutral-100 text-neutral-600 border-neutral-200" },
  envoye: { label: "Envoyé", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  modification_demandee: { label: "Modification demandée", cls: "bg-yellow-50 text-yellow-700 border-yellow-200" },
  accepte: { label: "Validé", cls: "bg-green-50 text-green-700 border-green-200" },
  refuse: { label: "Refusé", cls: "bg-red-50 text-red-700 border-red-200" },
  annule: { label: "Annulé", cls: "bg-neutral-100 text-neutral-400 border-neutral-200" },
};

export const QUOTE_BILLING = {
  non_facture: { label: "Non facturé", cls: "bg-neutral-100 text-neutral-500 border-neutral-200" },
  acompte_facture: { label: "Acompte facturé", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  partiellement_facture: { label: "Partiellement facturé", cls: "bg-yellow-50 text-yellow-700 border-yellow-200" },
  entierement_facture: { label: "Entièrement facturé", cls: "bg-green-50 text-green-700 border-green-200" },
};

export const QUOTE_EDITABLE_STATUSES = ["brouillon", "envoye", "modification_demandee", "refuse"];

export const VALIDATION_MODE_LABELS = {
  client_en_ligne: "Client en ligne", email: "E-mail", whatsapp: "WhatsApp",
  signature_papier: "Signature papier",
  sms: "Message / SMS", telephone: "Téléphone", rdv: "Rendez-vous / Oral", autre: "Autre",
};

export const PAYMENT_METHODS = [
  ["virement", "Virement"], ["carte", "Carte bancaire"], ["especes", "Espèces"],
  ["cheque", "Chèque"], ["prelevement", "Prélèvement"], ["autre", "Autre"],
];

export const quoteNumber = (q) => (q.number ? `Devis N° ${q.number}` : q.original_number ? `N° ${q.original_number}` : "—");
